import React, { useState } from 'react';

const CRUDHooks = () =>{
    const [daftarBuah, setDaftarBuah] = useState([
            {nama: "Nanas", hargaTotal: 100000, beratTotal: 4000 },
            {nama: "Manggis", hargaTotal: 350000, beratTotal: 10000},
            {nama: "Nangka", hargaTotal: 90000, beratTotal: 2000},
            {nama: "Durian", hargaTotal: 400000, beratTotal: 5000},
            {nama: "Strawberry", hargaTotal: 120000, beratTotal: 6000}
        ]) 
    const [inputNama, setInputNama] = useState()
    const [inputHarga, setInputHarga] = useState()
    const [inputBerat, setInputBerat] = useState()
    const [showForm, setShowForm] = useState(false)
    const [statusForm, setStatusForm] = useState("create")
    const [currentIndex, setCurrentIndex] = useState(-1)

    const addNewDataBuah = () => {
        setInputNama("")
        setInputHarga()
        setInputBerat()
        setShowForm(true)
        setStatusForm("create")
    }

    const handleSubmit = (event) =>{
        event.preventDefault()
        if (currentIndex === -1){
            setDaftarBuah([...daftarBuah, {nama: inputNama, hargaTotal: inputHarga, beratTotal: inputBerat}])
        } else {
            daftarBuah[currentIndex] = {nama: inputNama, hargaTotal: inputHarga, beratTotal: inputBerat}
            setDaftarBuah(daftarBuah)
        }

        setCurrentIndex(-1)
        setInputNama("")
        setInputHarga()
        setInputBerat()
        setShowForm(false)
    }

    const handleEdit = (event) => {
        let index = Number(event.target.value)
        let currentDataBuah = daftarBuah[index]

        setStatusForm("edit")
        setCurrentIndex(index)
        setInputNama(currentDataBuah.nama)
        setInputHarga(currentDataBuah.hargaTotal)
        setInputBerat(currentDataBuah.beratTotal)
        setShowForm(true)
    }

    const handleDelete = (event) => {
        let index = Number(event.target.value)
        if (currentIndex !== -1){
            setCurrentIndex(-1)
            setInputNama("")
            setInputHarga()
            setInputBerat()
            setShowForm(false)
        }

        let newDataBuah = daftarBuah.filter((item) => {
            return item !== daftarBuah[index]
        })

        setDaftarBuah(newDataBuah)
    }

    const handleNamaBuah = (input) => {
        setInputNama(input.target.value)
    }

    const handleHargaBuah = (input) => {
        setInputHarga(input.target.value)
    }

    const handleBeratBuah = (input) => {
        setInputBerat(input.target.value)
    }

    
    return(
        <>
        <h1 className='App'>Daftar Harga Buah</h1>
        <table className='custom-table'>
            <thead>
                <tr>
                <th>No</th>
                <th>Nama</th>
                <th>Harga Total</th>
                <th>Berat Total</th>
                <th>Harga per kg</th>
                <th>Aksi</th>
                </tr>
            </thead>
            <tbody>
                {daftarBuah.map((value, index)=>{
                    return(
                        <tr key={index}>
                            <td>{index+1}</td>
                            <td>{value.nama}</td>
                            <td>{value.hargaTotal}</td>
                            <td>{value.beratTotal/1000} kg</td>
                            <td>{value.hargaTotal/(value.beratTotal/1000)}</td>
                            <td>
                                <button className="button-edit mr-10" onClick={handleEdit} value={index}>Edit</button>
                                <button className="button-delete" onClick={handleDelete} value={index}>Delete</button>
                            </td>
                        </tr>
                    )
                })}
                <tr>
                    <td></td>
                </tr>
            </tbody>
        </table>
        {!showForm && <button className='button-add' onClick={addNewDataBuah}> Tambah Data Buah</button>}
        {showForm && (
            <>
                <h1 className='App'>{statusForm === "create" ? "Tambah Data Buah Baru" : `Edit Data Buah ${currentIndex+1}`}</h1>
                <div className='custom-form'>
                    <form onSubmit={handleSubmit}>
                        <div className='custom-input'>
                            <label htmlFor='name'>Nama:</label>
                            <input required autoComplete='off' type="text" name='name' value={inputNama} onChange={handleNamaBuah} placeholder="Masukkan Nama Buah..." /> 
                            <br/>
                            <br/>
                            <label htmlFor='harga'>Harga Total:</label>
                            <input required autoComplete='off' type="number" name='harga' value={inputHarga} onChange={handleHargaBuah} placeholder="Masukkan Harga Buah..." /> 
                            <br/>
                            <label htmlFor='berat'>Berat Total (dalam gram) :</label>
                            <input required autoComplete='off' type="number" min="2000" name='berat' value={inputBerat} onChange={handleBeratBuah} placeholder="Masukkan Berat Buah..." /> 
                        </div>
                        <input type="submit" value="Submit"/>
                    </form>
                </div>
            </>
        )}
        </>
    )
}

export default CRUDHooks